module.exports = __webpack_public_path__ + "img/header-careers.ae5e31dc.jpg";